(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CrmNoteDeleteController',CrmNoteDeleteController);

    CrmNoteDeleteController.$inject = ['$uibModalInstance', 'entity', 'CrmNote'];

    function CrmNoteDeleteController($uibModalInstance, entity, CrmNote) {
        var vm = this;

        vm.crmNote = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CrmNote.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
